import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

// --------------------
// Type Definitions
// --------------------
export interface WeeklySchedule {
  id?: number;
  foodMenuItemId?: number;
  cookProfileId?: number;
  kitchenName?: string;
  scheduledDate?: any;
  mealTypeId?: number;
  quantityAvailable?: number;
  priceOverride?: number;
  deliveryStartTime?: string;
  deliveryEndTime?: string;
  preorderClosingDatetime?: string;
  specialMention?: string;
  isActive?: boolean;
  createdAt?: string;
  auditTrailId?: number;
  mealTypeName?: string;
  foodMenuName?: string;
  imageUrl?: string;
  packLevel?: number;
  packUnit?: string;
  spiceLevelId?: number;
  spiceLevelName?: string;
  areaCodes?: string;
  areaCodeNames?: string;
  weeklyScheduleId?: number;
}

// API response
interface ApiResponse {
  data: {
    data: WeeklySchedule[];
  };
}

// Slice state
interface WeeklyScheduleState {
  data: WeeklySchedule[];
  loading: boolean;
  error: string | null;
}

const COOKPORT = import.meta.env.VITE_COOK_PORT;
const COOKURL = import.meta.env.VITE_API_COOK_URL;

// --------------------
// Async Thunk
// --------------------
// export const fetchCustomeSerachWeeklySchedule = createAsyncThunk<
//   WeeklySchedule[],          // Return type
//   { weeklyScheduleId: any }, // Argument type
//   { rejectValue: string }    // ThunkAPI config
// >(
//   'WeeklySchedule/fetchWeeklySchedule',
//   async ({ weeklyScheduleId }, { rejectWithValue }) => {
//     try {
//       const response = await apiService.get<ApiResponse>(
//         `/custom_search_food_schedule`,
//         COOKPORT,
//         COOKURL
//       );
//       return response.data.data;
//     } catch (error) {
//       return rejectWithValue(
//         error instanceof Error ? error.message : 'An error occurred'
//       );
//     }
//   }
// );

export const fetchCustomeSerachWeeklySchedule = createAsyncThunk<
  WeeklySchedule[],
  { weeklyScheduleId: number },
  { rejectValue: string }
>(
  'WeeklySchedule/fetchCustomeSerachWeeklySchedule',
  async (params, { rejectWithValue }) => {
    try {
      const config = { params };
      const response = await apiService.get<any>(
        'custom_search_food_schedule',
        COOKPORT,
        COOKURL,
        config
      );
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'An error occurred');
    }
  }
);

// --------------------
// Slice
// --------------------
export const WeeklyFoodScheduleFeedSlice = createSlice({
  name: 'WeeklySchedule',
  initialState: {
    data: [],
    loading: false,
    error: null,
  } as WeeklyScheduleState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomeSerachWeeklySchedule.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomeSerachWeeklySchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCustomeSerachWeeklySchedule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Unknown error';
      });
  },
});

export default WeeklyFoodScheduleFeedSlice.reducer;
